var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "footer-navigation footer-software-provider" },
    [
      _c("ul", { staticClass: "footer-list" }, [
        _c(
          "li",
          { staticClass: "footer-list-item" },
          [
            _c("build-version", [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.aspedia.net",
                    target: "_blank",
                    rel: "noopener",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "logo-icon",
                      staticStyle: {
                        "enable-background": "new 0 0 158.421 156.794",
                      },
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        x: "0px",
                        y: "0px",
                        viewBox: "0 0 158.421 156.794",
                        "xml:space": "preserve",
                      },
                    },
                    [
                      _c("g", [
                        _c("path", {
                          staticClass: "st0",
                          attrs: {
                            d: "M48.61,103.573C38.495,37.282,68.656,0.649,68.656,0.649C5.01,11.341-0.954,68.579,0.104,81.485\n              C13.694,96.423,46.225,103.076,48.61,103.573z M1.053,90.875c0,0,8.557,56.755,68.551,65.288c-4.515-6.3-15.3-20.354-19.763-46\n              C45.139,109.219,22.737,105.962,1.053,90.875z M56.477,111.233c0,0,5.421,30.376,22.851,45.515c11.008,0.754,66.1-7.1,77.468-65.2\n              C126.664,109.578,91.188,116.539,56.477,111.233z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          staticClass: "st0",
                          attrs: {
                            d: "M77.204,0c0,0-32.376,36.718-22.029,104.753c7.149,0.928,65.908,7.665,102.641-23.02\n              C161.504,72.388,149.991,1.061,77.204,0z",
                          },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._t("copyright_text", function () {
                    return [
                      _vm._v(
                        "© " +
                          _vm._s(new Date().getFullYear()) +
                          " - Website by Aspedia"
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }